(ns portal.advertiser-configuration-page.view.core
  (:require ["@mui/material/Chip$default" :as Chip]
            [common.flags :refer [use-flag]]
            [common.queries :refer [use-query]]
            [common.resource.query.advertiser :as q]
            [common.widgets.advertiser-menu :refer [advertiser-menu]]
            [common.widgets.page :as page]
            [linked.core :as l]
            [portal.adserver-configuration-table.view :as adserver-configuration-table]
            [portal.advertiser-configuration-page.view.backup :as backup]
            [portal.advertiser-configuration-page.view.general :as general]
            [portal.service-keys.ocp]
            [portal.service-keys.view :as service-keys]
            [portal.third-party-credentials.view :refer [third-party-credentials]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def base-tabs
  (l/map :general {:label "General"
                   :on-click (fn [_e] (rf/dispatch [:form.advertiser-configuration/reset-state]))
                   :view general/general-tab}
         :backup {:label "Backup images"
                  :view backup/backup-image-tab
                  :container-sx #js {:overflow "hidden"}}
         :adserver {:label "Adserver configuration"
                    :view adserver-configuration-table/table
                    :container-sx #js {:overflow "hidden"}}
         :connections {:label "Third-party credentials"
                       :view third-party-credentials
                       :container-sx #js {:overflowY "auto"}}))

(defui advertiser-configuration-page []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {{:keys [archived] :as advertiser} :data} (use-query (q/advertiser-query {:advertiser-id advertiser-id}))
        service-keys-enabled? (use-flag :service-keys)
        tabs (cond-> base-tabs
               service-keys-enabled? (assoc :service-keys {:label        "Service Keys"
                                                           :view         service-keys/table
                                                           :container-sx #js {:overflow "hidden"}}))]
    (uix/use-effect (fn []
                      (rf/dispatch [:form.advertiser-configuration/set-initial-value advertiser]))
                    [advertiser])
    ($ page/page
       ($ page/page-header
          {:title "Advertiser configuration"
           :tabs tabs
           :buttons ($ advertiser-menu {:archived archived})}
          (when archived
            ($ Chip {:label "Archived"})))
       ($ page/active-tab
          {:tabs tabs}))))
